export const formatCurrency = (n) => parseFloat(n).toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// generated by https://chat.openai.com/
// export function addTargetBlankToAnchors(htmlString) {
//   const parser = new DOMParser(); // create a new HTML parser
//   const parsedDoc = parser.parseFromString(htmlString, "text/html"); // parse the HTML string into a document
//   const anchors = parsedDoc.getElementsByTagName("a"); // get all anchor tags in the document

//   for (let i = 0; i < anchors.length; i++) {
//     // loop through all anchor tags
//     anchors[i].setAttribute("target", "_blank"); // add the target="_blank" attribute
//   }

//   return parsedDoc.body.innerHTML; // return the modified HTML as a string
// }
export function addTargetBlankToAnchors(htmlString) {
  if (!htmlString) {
    return htmlString;
  }

  const regex = /<a\s+([^>]*)>/gi; // regular expression to match anchor tags

  const modifiedHtml = htmlString.replace(regex, function (match, p1) {
    // check if the anchor tag already has a target attribute
    if (p1.match(/\btarget\s*=/i)) {
      // replace the existing target attribute with target="_blank"
      return "<a " + p1.replace(/(\btarget\s*=\s*['"]?)[^'"\s]+(['"]?)/i, "$1_blank$2") + ">";
    } else {
      // add the target="_blank" attribute
      return "<a " + p1 + ' target="_blank">';
    }
  });

  return modifiedHtml;
}
